import React from "react";
import { GoodsInController } from "./GoodsInController";
import { GoodsInViewModel } from "./GoodsInViewModel";
import * as feedback from "../../common/Feedback/Feedback";
import * as log from "../../common/Feedback/Log";

export class GoodsInProvider extends React.Component {
  constructor(props) {
    super(props);
    this.viewModel = new GoodsInViewModel();
    this.logger = log;
    this.feedback = feedback;

    console.log(props);
  }

  render() {
    return (
      <GoodsInController
        viewModel={this.viewModel}
        log={this.logger}
        feedback={this.feedback}
        toggleTopbar={this.props.toggleTopbar}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/GoodsIn/GoodsInProvider.js